var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 4.09375C7.875 3.14408 8.645 2.375 9.59375 2.375H9.9375C10.8492 2.375 11.7235 2.73716 12.3682 3.38182C13.0128 4.02648 13.375 4.90082 13.375 5.8125V7.53125C13.375 8.48092 14.145 9.25 15.0938 9.25H16.8125C17.7242 9.25 18.5985 9.61216 19.2432 10.2568C19.8878 10.9015 20.25 11.7758 20.25 12.6875V15.7813C20.25 16.73 19.48 17.5 18.5313 17.5H9.59375C9.13791 17.5 8.70074 17.3189 8.37841 16.9966C8.05608 16.6743 7.875 16.2371 7.875 15.7813V4.09375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 5.81245C14.7516 4.65611 14.3352 3.53816 13.5776 2.66461C15.1114 3.06791 16.5106 3.87138 17.6321 4.99284C18.7536 6.1143 19.557 7.51351 19.9603 9.04736C19.0868 8.28972 17.9688 7.87334 16.8125 7.87495H15.0937C15.0026 7.87495 14.9151 7.83873 14.8507 7.77426C14.7862 7.7098 14.75 7.62236 14.75 7.5312V5.81245ZM5.46875 6.49995H6.5V15.7812C6.5 16.6017 6.82595 17.3886 7.40614 17.9688C7.98633 18.549 8.77324 18.8749 9.59375 18.8749H16.125V19.9062C16.125 20.8549 15.355 21.6249 14.4062 21.6249H5.46875C5.01291 21.6249 4.57574 21.4439 4.25341 21.1215C3.93108 20.7992 3.75 20.362 3.75 19.9062V8.2187C3.75 7.26903 4.52 6.49995 5.46875 6.49995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.7790d89770340fad106545350649c72d.svg";
export { ForwardRef as ReactComponent };